import ApiService from "../ApiService";
const user = JSON.parse(localStorage.getItem("user"));

export default class OrderService {
  static getList = async (params) => {
    let tenant_id = `tenant_id=${user.tenant.id}`;
    let num,
      sort,
      sort_by,
      property_id,
      cursor,
      progress,
      keyword,
      runner_request,
      runner_picked,
      date_start,
      date_end;
    if (params.num && params.num !== "") {
      num = `&num=${params.num}`;
    }
    if (params.sort && params.sort !== "") {
      sort = `&sort=${params.sort}`;
    }
    if (params.sort_by && params.sort_by !== "") {
      sort_by = `&sort_by=${params.sort_by}`;
    }
    if (params.property_id !== "") {
      property_id = `&property_id=${params.property_id}`;
    }
    if (params.cursor !== "") {
      cursor = `&cursor=${params.cursor}`;
    }
    if (params.progress !== "") {
      progress = `&progress=${params.progress}`;
    }
    if (params.runner_request !== "" && params.runner_request !== undefined) {
      runner_request = `&runner_request=${params.runner_request}`;
    }
    if (params.runner_picked !== "" && params.runner_request !== undefined) {
      runner_picked = `&runner_picked=${params.runner_picked}`;
    }
    if (params.keyword !== "") {
      keyword = `&keyword=${params.keyword}`;
    }
    if (params.date_start && params.date_start !== "") {
      date_start = `&date_start=${params.date_start}`;
    }
    if (params.date_end && params.date_end !== "") {
      date_end = `&date_end=${params.date_end}`;
    }

    if (user?.type === "staff" && user?.operational?.level === 1) {
      property_id = `&property_id=${user?.operational?.id}`;
    }

    const instance = await ApiService();
    return instance.get(
      `/transaction/order?${num || ""}${sort || ""}${sort_by || ""}${
        property_id || ""
      }${cursor || ""}${progress || ""}${runner_request || ""}${
        runner_picked || ""
      }${date_start || ""}${date_end || ""}${keyword || ""}`
    );
  };

  static getSummary = async (params) => {
    let tenant_id = `tenant_id=${user.tenant.id}`;
    let num,
      sort,
      sort_by,
      property_id,
      keyword,
      runner_request,
      runner_picked,
      date_start,
      date_end;
    if (params.num && params.num !== "") {
      num = `&num=${params.num}`;
    }
    if (params.sort && params.sort !== "") {
      sort = `&sort=${params.sort}`;
    }
    if (params.sort_by && params.sort_by !== "") {
      sort_by = `&sort_by=${params.sort_by}`;
    }
    if (params.property_id !== "") {
      property_id = `&property_id=${params.property_id}`;
    }
    if (params.runner_request !== "" && params.runner_request !== undefined) {
      runner_request = `&runner_request=${params.runner_request}`;
    }
    if (params.runner_picked !== "" && params.runner_request !== undefined) {
      runner_picked = `&runner_picked=${params.runner_picked}`;
    }
    if (params.keyword !== "") {
      keyword = `&keyword=${params.keyword}`;
    }
    if (params.date_start && params.date_start !== "") {
      date_start = `&date_start=${params.date_start}`;
    }
    if (params.date_end && params.date_end !== "") {
      date_end = `&date_end=${params.date_end}`;
    }

    if (user?.type === "staff" && user?.operational?.level === 1) {
      property_id = `&property_id=${user?.operational?.id}`;
    }

    const instance = await ApiService();
    return instance.get(
      `/transaction/order/summary?${num || ""}${sort || ""}${sort_by || ""}${
        property_id || ""
      }${runner_request || ""}${
        runner_picked || ""
      }${date_start || ""}${date_end || ""}${keyword || ""}`
    );
  };

  static getListUnpaid = async (params) => {
    let tenant_id = `tenant_id=${user.tenant.id}`;
    let num,
      sort,
      sort_by,
      property_id,
      cursor,
      keyword,
      paid,
      runner_request,
      runner_picked,
      date_start,
      date_end;
    if (params.num && params.num !== "") {
      num = `&num=${params.num}`;
    }
    if (params.sort && params.sort !== "") {
      sort = `&sort=${params.sort}`;
    }
    if (params.sort_by && params.sort_by !== "") {
      sort_by = `&sort_by=${params.sort_by}`;
    }
    if (params.property_id !== "") {
      property_id = `&property_id=${params.property_id}`;
    }
    if (params.cursor !== "") {
      cursor = `&cursor=${params.cursor}`;
    }
    if (params.runner_request !== "" && params.runner_request !== undefined) {
      runner_request = `&runner_request=${params.runner_request}`;
    }
    if (params.runner_picked !== "" && params.runner_request !== undefined) {
      runner_picked = `&runner_picked=${params.runner_picked}`;
    }
    if (params.keyword !== "") {
      keyword = `&keyword=${params.keyword}`;
    }
    if (params.date_start && params.date_start !== "") {
      date_start = `&date_start=${params.date_start}`;
    }
    if (params.date_end && params.date_end !== "") {
      date_end = `&date_end=${params.date_end}`;
    }

    if (user?.type === "staff" && user?.operational?.level === 1) {
      property_id = `&property_id=${user?.operational?.id}`;
    }

    paid = `&paid=false`

    const instance = await ApiService();
    return instance.get(
      `/transaction?${num || ""}${sort || ""}${sort_by || ""}${
        property_id || ""
      }${cursor || ""}${runner_request || ""}${
        runner_picked || ""
      }${date_start || ""}${date_end || ""}${keyword || ""}${paid || ""}`
    );
  };

  static getDetailOrderLog = async (orderID) => {
    const instance = await ApiService();
    return instance.get(`/transaction/order/logs/${orderID}`)
  }

  static downloadTransactionOrder = async (params) => {
    let tenant_id = `tenant_id=${user.tenant.id}`;
    let num,
      sort,
      sort_by,
      property_id,
      progress,
      keyword,
      runner_request,
      runner_picked,
      date_start,
      date_end;
    if (params.num && params.num !== "") {
      num = `&num=${params.num}`;
    }
    if (params.sort && params.sort !== "") {
      sort = `&sort=${params.sort}`;
    }
    if (params.sort_by && params.sort_by !== "") {
      sort_by = `&sort_by=${params.sort_by}`;
    }
    if (params.property_id !== "") {
      property_id = `&property_id=${params.property_id}`;
    }
    if (params.progress !== "") {
      progress = `&progress=${params.progress}`;
    }
    if (params.runner_request !== "" && params.runner_request !== undefined) {
      runner_request = `&runner_request=${params.runner_request}`;
    }
    if (params.runner_picked !== "" && params.runner_request !== undefined) {
      runner_picked = `&runner_picked=${params.runner_picked}`;
    }
    if (params.keyword !== "") {
      keyword = `&keyword=${params.keyword}`;
    }
    if (params.date_start && params.date_start !== "") {
      date_start = `&date_start=${params.date_start}`;
    }
    if (params.date_end && params.date_end !== "") {
      date_end = `&date_end=${params.date_end}`;
    }

    if (user?.type === "staff" && user?.operational?.level === 1) {
      property_id = `&property_id=${user?.operational?.id}`;
    }

    const instance = await ApiService();
    return instance.get(
      `/transaction/order/download?${num || ""}${sort || ""}${sort_by || ""}${
        property_id || ""
      }${progress || ""}${runner_request || ""}${runner_picked || ""}${
        date_start || ""
      }${date_end || ""}${keyword || ""}`
    );
  };

  static getListTransaction = async (params) => {
    let num,
      sort,
      property_id,
      cursor,
      progress,
      delivery_st,
      keyword,
      date_start,
      date_end;
    if (params.num && params.num !== "") {
      num = `&num=${params.num}`;
    }
    if (params.sort && params.sort !== "") {
      sort = `&sort=${params.sort}`;
    }
    if (params.property_id !== "") {
      property_id = `&property_id=${params.property_id}`;
    }
    if (params.cursor !== "") {
      cursor = `&cursor=${params.cursor}`;
    }
    if (params.progress !== "") {
      progress = `&progress=${params.progress}`;
    }
    if (params.delivery_st !== "") {
      delivery_st = `&delivery_st=${params.delivery_st}`;
    }
    if (params.keyword !== "") {
      keyword = `&keyword=${params.keyword}`;
    }
    if (params.date_start && params.date_start !== "") {
      date_start = `&date_start=${params.date_start}`;
    }
    if (params.date_end && params.date_end !== "") {
      date_end = `&date_end=${params.date_end}`;
    }

    if (user?.type === "staff" && user?.operational?.level === 1) {
      property_id = `&property_id=${user?.operational?.id}`;
    }

    const instance = await ApiService();
    return instance.get(
      `/transaction?${num || ""}${sort || ""}${property_id || ""}${
        cursor || ""
      }${progress || ""}${delivery_st || ""}${date_start || ""}${
        date_end || ""
      }${keyword || ""}`
    );
  };

  static getOrder = async (id) => {
    const instance = await ApiService();
    return instance.get(`transaction/order/${id}`);
  };

  static getTransaction = async (id) => {
    const instance = await ApiService();
    return instance.get(`transaction/${id}`);
  };

  static patchData = async (id, params) => {
    const instance = await ApiService();
    return instance.patch(`/transaction/order/${id}`, params);
  };

  static patchTransactionData = async (id, params) => {
    const instance = await ApiService();
    return instance.patch(`/transaction/${id}`, params);
  };

  static getPrintOrderTemplate = async (orderID) => {
    const instance = await ApiService();
    return instance.get(`/transaction/order/print/${orderID}`)
  }
}
